module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }]
  }, [_c('h1', [_vm._v("eSocial - Download de Arquivo")]), _vm._v(" "), _c('div', {
    staticClass: "widget-container fluid-height clearfix widget-content padded"
  }, [(_vm.error) ? _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "error",
      "description": _vm.error,
      "show-icon": "",
      "closable": false
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.error && _vm.formData.id) ? _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "Arquivo Carregado com Sucesso",
      "type": "success",
      "description": "Confira abaixo as informações do lote",
      "show-icon": "",
      "closable": false
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_vm._v(_vm._s(_vm.formData.lote))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_vm._v(_vm._s(_vm.formData.empresa_nome_fantasia) + " - " + _vm._s(_vm.formData.empresa_cnpj))]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_vm._v(_vm._s(_vm.formData.layout))]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.onDownloadArquivo
    }
  }, [_vm._v(_vm._s(_vm.formData.filename))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_vm._v(_vm._s(_vm.toDate(_vm.formData.updated_at, false)))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 text-center",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingDownload
    },
    on: {
      "click": _vm.onDownloadArquivo
    }
  }, [(!_vm.loadingDownload) ? _c('i', {
    staticClass: "fa fa-download"
  }) : _vm._e(), _vm._v("\n                    Baixar Arquivo\n                ")]), _vm._v(" "), _vm._m(6)], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Lote:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Empresa:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Layout:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Nome do Arquivo:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "border-bottom": "solid 1px #ccc"
    }
  }, [_c('b', [_vm._v("Última Atualização:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-md-12 text-center",
    staticStyle: {
      "margin-top": "30px",
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n                    O arquivo foi baixado automaticamente. Clique no botão acima para baixar novamente.\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-220a0178"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/lotes/download.vue
// module id = 1375
// module chunks = 45